/**
 * Streicht aus einem Vorschautext den Anfang, den die Zeile darüber schon sagt.
 *
 * 2026-08-26 (DESIGN-NORM B6, „keine Zeile wiederholt, was darüber steht"):
 * Auf der Projekte-Seite stand unter der Karte „Surf-Reise Marokko" als
 * Beschreibung „Surf-Reise MAROKKO, 31. Juli bis 8. August …" — die ersten
 * zwanzig Zeichen jeder Vorschau waren eine Kopie der Überschrift, die
 * unmittelbar darüber steht.
 *
 * Dasselbe Muster wie bei der Essenz-Vorschau (pre.2328), nur an anderer
 * Stelle. Deshalb ein eigenes Modul statt einer zweiten Kopie.
 *
 * ⚠️ Der Vergleich ignoriert Groß-/Kleinschreibung und Satzzeichen: geschrieben
 * wird „Surf-Reise Marokko" als Titel und „Surf-Reise MAROKKO," im Text.
 */

/** Vergleichsform: klein, ohne Satzzeichen, einfache Leerzeichen. */
function schlicht(s: string): string {
  return s
    .toLowerCase()
    .replace(/[.,;:!?„“"'()\[\]–—-]/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

export function vorschauOhneEcho(vorschau: string, titel: string): string {
  const text = (vorschau || "").trim();
  const titelWorte = schlicht(titel || "").split(" ").filter(Boolean);
  if (!text || titelWorte.length === 0) return text;

  // ⚠️ Beide Seiten muessen GLEICH zerlegt werden. Der erste Entwurf verglich
  // die Titelworte mit den Leerzeichen-Stuecken des Textes — "Surf-Reise" ist
  // dort EIN Stueck, in der Vergleichsform aber zwei Worte ("surf", "reise").
  // Der Vergleich schlug deshalb schon beim ersten Wort fehl.
  //
  // Jetzt laeuft ein Zeiger durch den ORIGINALTEXT und verbraucht dabei so
  // viele Titelworte, wie er findet. Die Stelle, an der er stehen bleibt, ist
  // der Beginn des Restes.
  let stelle = 0;
  let verbraucht = 0;
  const wortMuster = /[\p{L}\p{N}]+/gu;
  wortMuster.lastIndex = 0;
  let m: RegExpExecArray | null;
  while (verbraucht < titelWorte.length && (m = wortMuster.exec(text)) !== null) {
    if (m[0].toLowerCase() !== titelWorte[verbraucht]) break;
    verbraucht++;
    stelle = m.index + m[0].length;
  }

  // Gestrichen wird nur, wenn der GANZE Titel am Anfang steht. Ein einzelnes
  // gemeinsames Wort ist damit automatisch Zufall und kein Echo.
  //
  // ⚠️ Hier stand zuerst noch ein zweiter Waechter ("weniger als zwei Worte =
  // Zufall"). Die Gegenprobe hat gezeigt, dass er nichts faengt: jeder Fall,
  // den er abfangen sollte, faellt schon durch die Zeile darunter. Ein
  // Waechter, der nichts faengt, ist toter Code — er waere still verrottet.
  if (verbraucht < titelWorte.length) return text;

  return text.slice(stelle).replace(/^[\s,;:.\u2013\u2014-]+/, "").trim();
}
